export default __webpack_public_path__ + "static/media/23.8f6e9397.png";